export default __webpack_public_path__ + "static/media/keller-before-after2-mobile-2.2e77f341.svg";